

export default function RadioButtons({ ...props }) {

    const getUniqueID = () => {
        return "_" + Math.random().toString(36).substring(2, 9);
    };
    const componentId = props.id ? props.id : getUniqueID();

    return (
        <div className="flex flex-col justify-start">
            <div className="relative flex items-center leading-3 ">
                <div className="flex items-center justify-center space-x-4 text-base text-contrast-90">
                    {props.items.map((item, index) => {
                        return (
                            <div key={componentId + "-" + index}>
                                <label className="inline-flex items-center">
                                    <label
                                        htmlFor={componentId + "-" + index}
                                        className="flex items-center cursor-pointer"
                                    >
                                        <input
                                            type="radio"
                                            value={item.value}
                                            checked={props.checked === item.value}
                                            onChange={props.onValueChange}
                                            className="mr-1 cursor-pointer"
                                            name={props.name}
                                            id={componentId + "-" + index}
                                        />
                                        {item.label}
                                    </label>
                                </label>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
